import { createApiInstance } from "./Api";

const createAnnouncementService = () => {
  const Api = createApiInstance();

  return {
    createAnnouncement: async (announcementData: any) =>
      Api.post('/Announcements/create', announcementData),
  };
};

export default createAnnouncementService;
